var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{style:(`position: absolute; top: ${_vm.top}; left: ${_vm.left}; width: ${_vm.width}; height: ${_vm.height}`),attrs:{"data-image":_vm.image,"data-image-left":_vm.imageLeft,"data-image-top":_vm.imageTop,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }